<!-- ── Loading ─────────────────────────────────────────────────────────── -->
<ng-container *ngIf="state === 'loading'">
  <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" aria-hidden="true">
    <div *ngFor="let _ of cards" class="h-32 animate-pulse rounded-xl bg-slate-200"></div>
  </div>
  <span class="sr-only" role="status">Loading Azure data…</span>
</ng-container>

<!-- ── Not connected ───────────────────────────────────────────────────── -->
<ng-container *ngIf="state === 'not-connected'">
  <div class="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
    <div class="flex flex-col items-center gap-5 px-8 py-16 text-center">
      <div class="flex h-16 w-16 items-center justify-center rounded-2xl bg-slate-100">
        <lucide-icon name="cloud" [size]="28" class="text-slate-400" [strokeWidth]="1.5"></lucide-icon>
      </div>
      <div>
        <h3 class="text-sm font-semibold text-slate-900">Connect your Azure subscription</h3>
        <p class="mt-1.5 max-w-sm text-sm text-slate-500">
          KernalHQ uses an Azure service principal (app registration) with Reader access to monitor your Azure resources — no user passwords stored.
        </p>
      </div>
      <div class="flex flex-wrap justify-center gap-2">
        <span *ngFor="let c of cards" class="flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-xs font-medium text-slate-600">
          <lucide-icon [name]="c.icon" [size]="11" [strokeWidth]="2"></lucide-icon> {{ c.name }}
        </span>
      </div>
      <a
        routerLink="/settings/integrations"
        class="mt-1 flex items-center gap-2 rounded-lg bg-violet-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-offset-2"
      >
        <lucide-icon name="settings" [size]="14" [strokeWidth]="2"></lucide-icon>
        Connect Azure
      </a>
    </div>
  </div>
</ng-container>

<!-- ── Error ───────────────────────────────────────────────────────────── -->
<ng-container *ngIf="state === 'error'">
  <div class="flex items-start gap-3 rounded-lg border border-red-200 bg-red-50 px-4 py-3" role="alert">
    <lucide-icon name="triangle-alert" [size]="15" class="mt-0.5 flex-shrink-0 text-red-500" [strokeWidth]="2"></lucide-icon>
    <div>
      <p class="text-sm text-red-700">Failed to load the Azure integration.</p>
      <a routerLink="/settings/integrations" class="mt-0.5 inline-block text-xs font-medium text-red-600 underline hover:text-red-800">
        Check connection settings →
      </a>
    </div>
  </div>
</ng-container>

<!-- ── Connected ───────────────────────────────────────────────────────── -->
<ng-container *ngIf="state === 'connected'">
  <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
    <app-service-card
      *ngFor="let card of cards"
      [card]="card"
      [loading]="isCardLoading(card.id)"
      [account]="subscription"
      [region]="location"
    ></app-service-card>
  </div>
</ng-container>
